const configure = {
    state:{
        HOST: process.env.VUE_APP_BASE_API || '/api',
    },
    getters: {
              
    },
    mutations: {
        
    }
}

export default configure